import { BlogSection } from '@/types/blog';

export const menschSeinSection: BlogSection = {
  id: 'mensch-sein',
  title: 'Mensch sein – emotional, verletzlich, verbunden',
  content: `
    <p>
      Wir sind soziale Wesen und brauchen Nähe, Austausch und Zugehörigkeit. Viele Konflikte entstehen nicht durch Fakten, sondern durch unregulierte Gefühle wie Wut, Ohnmacht oder Scham. Je mehr wir uns selbst verstehen, desto besser können wir auch andere verstehen und mit ihnen in Kontakt bleiben, selbst wenn es schwierig wird. Das ist keine Schwäche, sondern eine Stärke, die wir dringend brauchen.
    </p>
  `
};
